import { buildModelManager } from "../builder.js";
const DefaultInstitutionVectorStoreSelection = {
  __typename: true,
  id: true,
  accessibleByRoles: true,
  agentsAuthorized: true,
  contentType: true,
  createdAt: true,
  createdById: true,
  description: { markdown: true, truncatedHTML: true },
  fileCount: true,
  institutionId: true,
  isActive: true,
  lastSyncedAt: true,
  metadata: true,
  name: true,
  updatedAt: true,
  vectorStoreId: true
};
const modelApiIdentifier = "institutionVectorStore";
const pluralModelApiIdentifier = "institutionVectorStores";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByVectorStoreId",
    findByField: "vectorStoreId",
    findByVariableName: "vectorStoreId",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByVectorStoreId",
    findByField: "vectorStoreId",
    findByVariableName: "vectorStoreId",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionVectorStoreSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createInstitutionVectorStore",
    operationReturnType: "CreateInstitutionVectorStore",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      institutionVectorStore: { required: false, type: "CreateInstitutionVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkCreateInstitutionVectorStores",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateInstitutionVectorStoresInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "action",
    operationName: "updateInstitutionVectorStore",
    operationReturnType: "UpdateInstitutionVectorStore",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionVectorStore: { required: false, type: "UpdateInstitutionVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateInstitutionVectorStores",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateInstitutionVectorStoresInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "action",
    operationName: "deleteInstitutionVectorStore",
    operationReturnType: "DeleteInstitutionVectorStore",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteInstitutionVectorStores",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertInstitutionVectorStore",
    operationReturnType: "UpsertInstitutionVectorStore",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      institutionVectorStore: { required: false, type: "UpsertInstitutionVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateInstitutionVectorStoreResult": { hasReturnType: false },
      "... on UpdateInstitutionVectorStoreResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertInstitutionVectorStores",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertInstitutionVectorStoresInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultInstitutionVectorStoreSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "institutionVectorStoreGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const InstitutionVectorStoreManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultInstitutionVectorStoreSelection,
  operations
);
export {
  DefaultInstitutionVectorStoreSelection,
  InstitutionVectorStoreManager
};
//# sourceMappingURL=InstitutionVectorStore.js.map
